<template>
  <div>
    <!-- List -->
    <div>
      <vs-table
        id="product_list"
        class="vs-con-loading__container"
        stripe
        :sst="true"
        maxHeight="800px"
        @search="updateSearchQuery"
        @change-page="handleChangePage"
        @sort="handleSort"
        :total="FilteredCount"
        :max-items="length"
        search
        :data="records"
      >
        <template slot="header">
          <div class="mb-2 flex items-center">
            <div class="flex flex-wrap justify-between items-center">
              <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                <vs-dropdown vs-trigger-click class="cursor-pointer filter-font">
                  <div class="p-4 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                    <span class="mr-2">
                      {{ page * length - (length - (FilteredCount && 1)) || 0 }}
                      -
                      {{ FilteredCount - page * length > 0 ? page * length : FilteredCount }}
                      of {{ total || 0 }}
                    </span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="handleChangeLength(10)">
                      <span>10</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(20)">
                      <span>20</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(50)">
                      <span>50</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(100)">
                      <span>100</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </div>
            <div
              v-if="checkPermissionSlug(['learning_mode_create', 'audio_create'])"
              @click="createLetter"
              class="btn-add-new p-2 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-primary border border-solid border-primary"
            >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add {{ module_name }}</span>
            </div>

            <div class="flex flex-wrap items-center">
              <!-- Custom Pagination -->
              <vs-pagination v-if="FilteredCount" v-model="page" :total="totalPages" :max="totalPages / length > 7 ? 7 : 5" class="mt-1" @onchange="handleChangePage"></vs-pagination>
            </div>
          </div>
        </template>

        <template slot="thead">
          <vs-th>Sr#</vs-th>
          <vs-th sort-key="punjabi_letter">Punjabi Letter</vs-th>
          <vs-th sort-key="english_letter">English Letter</vs-th>
          <vs-th sort-key="english_pronounce">English Pronounce</vs-th>
          <vs-th>Audio</vs-th>
          <vs-th sort-key="sorting">Index</vs-th>
          <vs-th v-if="checkPermissionSlug(['learning_mode_edit', 'audio_edit']) || checkPermissionSlug(['learning_mode_delete', 'audio_delete'])">Action</vs-th>
        </template>

        <template slot-scope="{ data }" ref="tableBody">
          <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
            <vs-td>
              {{ page * length - (length - i - 1) }}
            </vs-td>
            <!-- <vs-td class="text-left">
              <span class="cursor-pointer" v-if="checkPermissionSlug(['audio_edit'])" @click.stop="toggleEditModal(tr)" v-tooltip="{ content: `Edit ${tr.title}` }">{{ tr.title || '-' }} </span>
              <span v-else>{{ tr.title || '-' }} </span>
            </vs-td> -->
            <vs-td class="text-left">{{ tr.punjabi_letter || '-' }} </vs-td>
            <vs-td class="text-left">{{ tr.english_letter || '-' }} </vs-td>
            <vs-td class="text-left">{{ tr.english_pronounce || '-' }} </vs-td>
            <vs-td class="text-left">
              <audio ref="audios" :src="tr.audio_recording" controls @play="handlePlay(i)"></audio>
            </vs-td>
            <vs-td class="text-left w-1/6" v-if="checkRolesByIds(['admin'])">
              <vs-input
                v-if="!tr.is_active"
                :value="tr.sorting"
                v-validate="'required'"
                type="number"
                step="0.1"
                class="w-1/2"
                @click.stop
                @input="debouncedUpdateSorting(tr._id, $event)"
                
              />
              <span v-else> - </span>
            </vs-td>
            <vs-td v-if="checkPermissionSlug(['learning_mode_edit', 'audio_edit']) || checkPermissionSlug(['learning_mode_delete', 'audio_delete'])">
              <div class="inline-flex">
                <vx-tooltip :text="`Edit ${module_name}`" v-if="checkPermissionSlug(['learning_mode_edit', 'audio_edit'])">
                  <feather-icon @click.stop="editLetter(tr._id)" icon="EditIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" />
                </vx-tooltip>
                <vx-tooltip :text="`Delete ${module_name}`" v-if="checkPermissionSlug(['learning_mode_delete', 'audio_delete'])">
                  <feather-icon @click.stop="deleteRecord(tr._id)" icon="Trash2Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" />
                </vx-tooltip>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>

  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'LetterList',

  /** Data */
  data() {
    return {
      order: [],
      length: 100,
      page: 1,
      search: '',
      module_name: 'Punjabi Letter',
      sortingTimeouts: {} // Store timeouts for each record
    }
  },

  /** computed */
  computed: {
    ...mapState('learningMode', ['records', 'total', 'FilteredCount', 'listLoading']),
    ...mapGetters('auth', ['checkPermissionSlug', 'checkRolesByIds']),
    totalPages() {
      return Math.ceil(this.FilteredCount / this.length)
    }
  },

  /** Functions */
  methods: {
    ...mapActions('learningMode', {
      get: 'get',
      delete: 'delete',
      show: 'show',
      manageIndexNumber: 'manageIndexNumber'
    }),

    debouncedUpdateSorting(id, value) {
    // Clear existing timeout for this record
      if (this.sortingTimeouts[id]) {
        clearTimeout(this.sortingTimeouts[id])
      }
    
      // Set new timeout - API call after 2 seconds of no typing
      this.sortingTimeouts[id] = setTimeout(() => {
        this.updateSorting(id, value)
      }, 2000) // 2 seconds delay
    },

    async updateSorting(id, value) {
    // Skip if empty or invalid
      if (!value || value.trim() === '') return
    
      const sortingValue = parseFloat(value)
    
      // Validate if it's a valid number
      if (isNaN(sortingValue)) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please enter a valid number (e.g., 2.5, 3)',
          iconPack: 'feather',
          position: 'top-center',
          time: 3000,
          icon: 'icon-alert-circle',
          color: 'danger'
        })
        return
      }
    
      try {
      // Show loading notification
        this.$vs.notify({
          title: 'Updating...',
          text: `Setting sorting value to ${sortingValue}`,
          iconPack: 'feather',
          position: 'top-center',
          time: 1000,
          icon: 'icon-clock',
          color: 'primary'
        })

        const { message } = await this.manageIndexNumber({
          id,
          sorting: sortingValue // Send as decimal number
        })
      
        this.$vs.notify({
          title: 'Success',
          text: message || `Sorting updated to ${sortingValue}`,
          iconPack: 'feather',
          icon: 'icon-check',
          position: 'top-center',
          time: 3000,
          color: 'success'
        })
      
        // Refresh data to show updated values
        this.getData()
      
      } catch (error) {
        const errorMessage =
          (error && error.message) ||
          (error && error.response && error.response.data && error.response.data.message) ||
          'Failed to update sorting'

        this.$vs.notify({
          title: 'Error',
          text: errorMessage,
          iconPack: 'feather',
          position: 'top-center',
          time: 4000,
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },

    // Clean up timeouts when component is destroyed
    clearAllTimeouts() {
      Object.values(this.sortingTimeouts).forEach(timeout => {
        if (timeout) clearTimeout(timeout)
      })
      this.sortingTimeouts = {}
    },

    /**
     * Handle the play event for an audio element.
     * Pauses all other audios except the one being played.
     * @param {Number} currentIndex - The index of the audio being played.
     */

    handlePlay(currentIndex) {
      if (this.$refs.audios) {
        // Convert $refs.audios to an array if it's not already
        const audios = Array.isArray(this.$refs.audios) ? this.$refs.audios : [this.$refs.audios]

        audios.forEach((audio, index) => {
          if (index !== currentIndex) {
            audio.pause()
          }
        })
      }
    },
    /**
     * Pause all audio elements and reset their playback.
     */

    pauseAllAudios() {
      if (this.$refs.audios) {
        const audios = Array.isArray(this.$refs.audios) ? this.$refs.audios : [this.$refs.audios]

        audios.forEach((audio) => {
          audio.pause()
          audio.currentTime = 0
        })
      }
    },

    clearDateRange() {
      this.dateRange = null // Clear the dateRange value
    },

    /** Per Page Limit Change */
    handleChangeLength(length) {
      this.page = 1
      this.length = length
      this.getData()
    },

    /** Page Change */
    handleChangePage(page) {
      this.page = page
      this.getData()
    },

    /** Sorting Table Data */
    handleSort(key, active) {
      if (!key) return
      this.page = 1
      this.order = [key, active === 'desc' ? 'DESC' : 'ASC']
      this.getData()
    },

    /** Search Query */
    updateSearchQuery(val) {
      this.page = 1
      this.search = val
      this.getData()
    },

    /** List API */
    getData() {
      this.get({
        limit: this.length,
        page: this.page,
        search: this.search
      })
    },

    /** Add Letter */
    createLetter() {
      this.$router.push(`/punjabi-letter/add`)
    },

    /** Edit Letter */
    editLetter(id) {
      this.$router.push(`/punjabi-letter/${id}/edit`)
    },

    /** Delete Confirmation */
    deleteRecord(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Delete`,
        text: `Are you sure you want to delete this record?`,
        accept: () => this.deleteSingleRecord(id),
        acceptText: 'Delete'
      })
    },

    /** Delete API */
    async deleteSingleRecord(id) {
      try {
        const { message } = await this.delete(id)
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
        this.getData()
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          position: 'top-center',
          time: 5000,
          icon: 'icon-alert-circle',
          color: 'primary'
        })
      }
    }
  },

  /** Watchers */
  watch: {
    dateRange() {
      this.page = 1 // Reset to the first page when date range changes
      this.getData()
    },
    listLoading() {
      if (this.listLoading) {
        this.$vs.loading({
          container: '#product_list',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#product_list > .con-vs-loading')
      }
    },

    page() {
      this.getData()
    }
  },

  // Add this to handle cleanup
  beforeDestroy() {
    this.clearAllTimeouts()
  },

  /** On Rendering */
  mounted() {
    this.getData()
  }
}
</script>
<style>
.input-group .feather-icon {
  position: absolute;
  top: 30px;
  right: 10%;
  transform: translateY(-50%);
  cursor: pointer;
}
#dateRange {
  width: 350px !important;
}
</style>
